
    import "src/app/AppSeller/Orders/ManualOrder/index.module.scss?farm_css_modules";
    
    export default {"backButton": `backButton-86d00a5b`,"cardStyle": `cardStyle-86d00a5b`,"heading": `heading-86d00a5b`,"innerContainer": `innerContainer-86d00a5b`,"manualOrder": `manualOrder-86d00a5b`,"outerContainer": `outerContainer-86d00a5b`,"sidebar": `sidebar-86d00a5b`}
    